export const environment = {
  production: true,
  url: 'https://jm-software.nl:5435/v1/api',
  redirectUrl: 'https://acc.iq-administration.jm-software.nl/finish-payment'
};
